import Vue from 'vue'
import App from './App.vue'
import router from './router'
import i18n from './locales'
import store from "./store";
import ElementUI from 'element-ui'
import Toast from "@/components/ToastShow";
import { initAliCodeValidate } from "@/components/aliCodeValidate/handleDialog";
import _ from "lodash";
import "@/icons/index";
import "./assets/styles/index.scss";
import scroll from "vue-seamless-scroll";
import utils from "@/utils/index";
import FmButton from "@/components/Button";
import FmInput from "@/components/FmInput";
import HToast from '@/components/Toast/index.vue'
import myConfig from "@/utils/config/index";
import VueClipboard from 'vue-clipboard2'

Vue.use(VueClipboard)
Vue.use(ElementUI) // 全局注册所有组件
Vue.use(scroll);
Vue.prototype._ = _;
Vue.prototype.$utils = utils;
Vue.prototype.$glb = myConfig;
Vue.prototype.$AliCode = initAliCodeValidate();

// 定义插件对象
const ToastObj = {
  install: function (Vue) {
    // 创建一个Vue的“子类”组件
    const ToastConstructor = Vue.extend(Toast);
    // 创建一个该子类的实例,并挂载到一个元素上
    const instance = new ToastConstructor();
    // 将这个实例挂载到动态创建的元素上,并将元素添加到全局结构中
    instance.$mount(document.createElement("div"));
    document.body.appendChild(instance.$el);
    // 在Vue的原型链上注册方法，控制组件
    Vue.prototype.$toast = (msg, state) => {
      instance.showToastfun(msg, state);
    };
    Vue.prototype.$toastClose = () => {
      instance.close();
    };
    setTimeout(() => {
      document.body.removeChild(instance.$el);
    }, 3000);
  },
};
let isShowing = false
// 定义插件对象
const ToastObj2 = {
  install: function (Vue) {
    // 创建一个Vue的“子类”组件
    const ToastConstructor = Vue.extend(HToast);
    // 创建一个该子类的实例,并挂载到一个元素上
    const instance = new ToastConstructor();
    // 将这个实例挂载到动态创建的元素上,并将元素添加到全局结构中
    instance.$mount(document.createElement("div"));
    document.body.appendChild(instance.$el);
    // 添加全局方法
    Vue.prototype.$htoast = function(msg,time) {
      // 防连点：如果正在显示则不重复显示
      if (isShowing) return
      
      isShowing = true
      
      // 调用实例的show方法
      instance.show(msg,time)
      
      // 监听消失，重置状态
      setTimeout(() => {
        isShowing = false
      }, instance.duration + 300) // 加上动画时间
    }
  },
};
Vue.component(FmButton.name, FmButton);
Vue.component(FmInput.name, FmInput);
Vue.use(ToastObj);
Vue.use(ToastObj2);
new Vue({
  store,
  router,
  i18n,
  render: h => h(App)
}).$mount('#app')
